import clsx from 'clsx'
import Cta from '.'
import type { NavigationItemFragment } from '@/lib/types/datocms/graphql/generated'
import type { IconType } from '@/components/svg/icon'
import Icon from '@/components/svg/icon'

type Props = {
	cta: NavigationItemFragment
	icon?: {
		icon: IconType
		orientation: 'left' | 'right'
		size?: 'sm' | 'md'
	}
	variant?: 'primary' | 'secondary' | 'tertiary'
	onClick?: () => void
	className?: string
	closeMegaMenu?: boolean
	isInternational?: boolean
}

export default function CtaLarge({
	cta,
	icon,
	variant = 'primary',
	className,
	onClick,
	closeMegaMenu,
	isInternational,
	...props
}: Props & React.HTMLProps<HTMLButtonElement>) {
	return (
		<Cta
			cta={cta}
			className={clsx(
				'cta text-sm p-4 justify-center [&_span]:ml-0',
				{
					primary: 'text-white bg-blue hover:bg-blue-shade hover:text-white',
					secondary:
						'text-blue-dark bg-white-frosted [&_svg]:text-blue [&_span]:text-blue hover:bg-white-frosted-shade',
					tertiary:
						'text-blue-dark bg-white-frosted border border-blue [&_span]:text-blue hover:bg-white-frosted-shade',
				}[variant],
				{ 'flex-row-reverse': icon?.orientation === 'right' },
				className
			)}
			isInternational={isInternational}
			onClick={onClick}
			{...props}
			closeMegaMenu={closeMegaMenu}
		>
			{icon ? <Icon icon={icon.icon} className={icon.size === 'sm' ? 'max-w-4 ' : ''} /> : null}
			<span className="tracking-wider">{cta.label ?? 'Learn more'}</span>
		</Cta>
	)
}
